import React, { useRef, useEffect, useState } from 'react';
import Loader from 'features/Loader/Loader';
import { Scrollbars } from 'react-custom-scrollbars';
import EmojiHappy from 'assets/img/icons/emoji/emoji-happy.png';
import EmojiSmile from 'assets/img/icons/emoji/emoji-smile.png';
import EmojiSad from 'assets/img/icons/emoji/emoji-sad.png';
import { MOOD_POLL_KEY } from 'utils/constants/messages';
import TimelineLoad from 'features/timeline/components/timelineLoad';
import { messageDate } from 'utils/date';
import Kickstart from './Kickstart';

const MessageList = ({
  messages,
  isKickstartCompleted,
  currentPage,
  getMessagesPrevPage,
  trainer,
  isMessagesLoading
}) => {
  const messagesEndRef = useRef(null);
  const [scrollDown, setScrollDown] = useState(true);
  const [lastScrollHeight, setLastScroll] = useState(0);

  useEffect(() => {
    const newScrollHeight = messagesEndRef.current.getScrollHeight();
    if (scrollDown) messagesEndRef.current.scrollToBottom();
    else messagesEndRef.current.scrollTop(newScrollHeight - lastScrollHeight);
    setScrollDown(true);
    setLastScroll(newScrollHeight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages]);

  return (
    <div className="message-list-container">
      {isMessagesLoading ? (
        <Loader />
      ) : (
        <Scrollbars autoHide={true} ref={messagesEndRef}>
          <ul className="message-list">
            {currentPage && currentPage.hasPrevPage ? (
              <TimelineLoad
                handleLoadMore={() => {
                  setScrollDown(false);
                  getMessagesPrevPage(currentPage);
                }}
              />
            ) : (
              <Kickstart isCompleted={isKickstartCompleted} />
            )}
            {messages &&
              messages.map(message => (
                <li
                  key={message.sid}
                  className={`message-row ${
                    message.author === trainer.uid
                      ? 'message-row-right'
                      : 'message-row-left'
                  }`}
                >
                  <span className="msg-time">
                    {messageDate(message.dateUpdated)}
                  </span>
                  <div className="message-default">
                    <p>{message.body}</p>
                    {message.attributes[MOOD_POLL_KEY] && (
                      <div className="emoji-section">
                        <span className="emoji-block">
                          <img src={EmojiSad} alt="sad" />
                        </span>
                        <span className="emoji-block">
                          <img src={EmojiSmile} alt="smile" />
                        </span>
                        <span className="emoji-block">
                          <img src={EmojiHappy} alt="happy" />
                        </span>
                      </div>
                    )}
                  </div>
                </li>
              ))}
          </ul>
        </Scrollbars>
      )}
    </div>
  );
};

export default MessageList;
